export default "__VITE_ASSET__D1u$nuWP__"